import React, { useState, useContext } from "react";
import "./css/UserRole.css";
import Modal from "react-bootstrap/Modal";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { LoginContext } from "../context/LoginContext";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Moshtarian from "./Moshtarian";
import AddModir from "./AddModir";
import Upload from "./Upload";
import useTheme from "./useTheme";
import Faq from "./Faq";
import Share from "./Share";
import Report from "./Report";
import FeeSale from "./FeeSale";
import Profile from "./Profile";
import VitrinMessage from "./VitrinMessage";
import ManageComments from "./ManageComments";
import ManageMsgToModir from "./ManageMsgToModir";
import MessageToModir from "./MessageToModir";
import Order from "./Order";

const Login = (props) => {
  const [showLogin, setShowLogin] = useState(false);

  const [showSignup, setShowSignup] = useState(false);

  const [showForgetPass, setShowForgetPass] = useState(false);

  const [loginMobile, setLoginMobile] = useState("");

  const [loginPass, setLoginPass] = useState("");

  const [forgetMobile, setForgetMobile] = useState("");

  const [signUpName, setSignUpName] = useState("");

  const [signUpMobile, setSignUpMobile] = useState("");

  const [signUpPass, setSignUpPass] = useState("");

  const [signUpAddress, setSignUpAddress] = useState("");

  const [signUpWork, setSignUpWork] = useState("مشتری خانگی");

  const [signUpMoaref, setSignUpMoaref] = useState("");

  const [alreadyPass, setAlreadyPass] = useState("");

  const [newPass, setNewPass] = useState("");

  const [repeatNewPass, setRepeatNewPass] = useState("");

  const [showSignUpMsg, setShowSignUpMsg] = useState([false, ""]);

  const [showLoginMsg, setShowLoginMsg] = useState([false, ""]);

  const [showForgetMsg, setShowForgetMsg] = useState([false, ""]);

  const [showChangePassRes, setShowChangePassRes] = useState([false, ""]);

  const [changePassMsg, setChangePassMsg] = useState("");

  const [showHistory, setShowHistory] = useState(false);

  const [showSefareshat, setShowSefareshat] = useState(false);

  const [showChangePass, setShowChangePass] = useState(false);

  const [historyResult, setHistoryResult] = useState([]);

  const [sefareshat, setSefareshat] = useState([]);

  const [loginMobileValidate, setLoginMobileValidate] = useState(true);

  const [loginPassValidate, setLoginPassValidate] = useState(true);

  const [forgetMobileValidate, setForgetMobileValidate] = useState(true);

  const [signUpNameValidate, setSignUpNameValidate] = useState(true);

  const [signUpMobileValidate, setSignUpMobileValidate] = useState(true);

  const [signUpAddressValidate, setSignUpAddressValidate] = useState(true);

  const [signUpMoarefValidate, setSignUpMoarefValidate] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const [theme, switchTheme] = useTheme();

  const loginContext = useContext(LoginContext);

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

  const loader = () => (
    <div className="row justify-content-center m-5 p-5">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );

  const setLoginMobileInput = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setLoginMobile(e.target.value);
  };

  const setLoginPassInput = (e) => {
    setLoginPass(p2e(a2e(e.target.value)));
  };

  const setForgetMobileInput = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setForgetMobile(e.target.value);
  };

  const setSignUpNameInput = (e) => {
    setSignUpName(e.target.value);
  };

  const setSignUpMobileInput = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setSignUpMobile(e.target.value);
  };

  const setSignUpPassInput = (e) => {
    setSignUpPass(p2e(a2e(e.target.value)));
  };

  const setSignUpAddressInput = (e) => {
    setSignUpAddress(e.target.value);
  };

  const setSignUpWorkInput = (e) => {
    setSignUpWork(e.target.value);
  };

  const setSignUpMoarefInput = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setSignUpMoaref(e.target.value);
  };

  const setAlreadyPassInput = (e) => {
    setAlreadyPass(p2e(a2e(e.target.value)));
  };

  const setNewPassInput = (e) => {
    setNewPass(p2e(a2e(e.target.value)));
  };

  const setRepeatPassInput = (e) => {
    setRepeatNewPass(p2e(a2e(e.target.value)));
  };

  const login = () => {
    setIsLoading(true);
    if (loginMobile.length < 11 || loginMobile[0] + loginMobile[1] != "09") {
      setLoginMobileValidate(false);
      return;
    } else {
      setLoginMobileValidate(true);
    }
    if (loginPass.length < 4) {
      setLoginPassValidate(false);
      return;
    } else {
      setLoginPassValidate(true);
    }
    const form = new FormData();
    form.append("login", 1);
    form.append("vitrinCode", props.id);
    form.append("mobile", loginMobile);
    form.append("password", loginPass);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        if (data.result === true) {
          loginContext.login(data.data);
        } else {
          setShowLoginMsg([true, "رمز عبور یا شماره موبایل اشتباه است"]);
        }
      })
      .catch((e) => {
        console.log(e);
        setShowLoginMsg([true, "اشکال در برقراری ارتباط با سرور"]);
        setIsLoading(false);
      });
  };

  const signUp = () => {
    setIsLoading(true);
    if (signUpName.length < 6) {
      setSignUpNameValidate(false);
      return;
    } else {
      setSignUpNameValidate(true);
    }

    if (signUpMobile.length < 11 || signUpMobile[0] + signUpMobile[1] != "09") {
      setSignUpMobileValidate(false);
      return;
    } else {
      setSignUpMobileValidate(true);
    }

    if (
      (signUpMoaref.length < 11 || signUpMoaref[0] + signUpMoaref[1] != "09") &&
      signUpMoaref.length !== 0
    ) {
      setSignUpMoarefValidate(false);
      return;
    } else {
      setSignUpMoarefValidate(true);
    }

    // if (signUpAddress.length < 5) {
    //   setSignUpAddressValidate(false);
    //   return;
    // } else {
    //   setSignUpAddressValidate(true);
    // }

    const form = new FormData();
    form.append("signUp", 1);
    form.append("vitrinCode", props.id);
    form.append("mobile", signUpMobile);
    form.append("name", signUpName);
    form.append("address", signUpAddress);
    form.append("work", signUpWork);
    form.append("moaref", signUpMoaref);

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        setShowSignUpMsg([true, data.data]);
        setShowSignup(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
        setShowSignUpMsg([true, "مشکل در برقراری ارتباط با سرور"]);
        setShowSignup(false);
      });
  };

  const forgetPass = () => {
    setIsLoading(true);
    if (loginMobile.length < 11 || loginMobile[0] + loginMobile[1] != "09") {
      setLoginMobileValidate(false);
      return;
    } else {
      setLoginMobileValidate(true);
    }

    const form = new FormData();
    form.append("forget_pass", 1);
    form.append("mobile", loginMobile);
    form.append("vitrinCode", props.id);

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );

    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        setShowForgetMsg([true, data.data]);
        setShowForgetPass(false);
        setForgetMobile("");
      })
      .catch((e) => {
        console.log(e);
        setShowForgetMsg([true, "اشکال در برقراری ارتباط با سرور"]);
        setIsLoading(false);
        setShowForgetPass(false);
      });
  };

  const logout = () => {
    setShowLogin(false);
    setLoginMobile("");
    setLoginPass("");
    loginContext.logout();
  };

  const showForget = () => {
    setShowLogin(false);
    setShowForgetPass(true);
  };

  const history = () => {
    const form = new FormData();
    form.append("history_sefaresh", 1);
    form.append("mobile", loginContext.userInfo.mobile);
    form.append("vitrinCode", props.id);

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );

    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        const array = [];
        if (data !== null) {
          data.map((item) => {
            if (array[0] === undefined) {
              array.push([item]);
            } else {
              const exist = array.findIndex(
                (val) => val[0].pk_sefaresh_mobile === item.pk_sefaresh_mobile
              );
              if (exist >= 0) {
                const arr = array[exist];
                arr.push(item);
                array.splice(exist, 1, arr);
              } else {
                array.push([item]);
              }
            }
          });
          const res = [];
          array.map((item) => {
            const num = 1 + item[0].pk_sefaresh_mobile;
            const date = item[0].tarikh;
            const radif = [];
            item.map((val, index) => {
              const radifNum = index + 1;
              const tedad = val.tedad;
              const vazn = val.vazn;
              const kala = val.kalaName;
              const obj = {
                radifNum: radifNum,
                tedad: tedad,
                vazn: vazn,
                kala: kala,
              };
              radif.push(obj);
            });
            const obj = {
              num: num,
              date: date,
              radif: radif,
            };
            res.push(obj);
          });
          setHistoryResult(res);
          setShowHistory(true);
        } else {
          setHistoryResult("سفارشی یافت نشد");
          setShowHistory(true);
        }
      });
  };

  const sefareshatFunc = () => {
    const form = new FormData();
    form.append("getSaleReport", 1);
    form.append("vitrinCode", props.id);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result && data.data.length>0) {
          setSefareshat(data.data);
          console.log(data.data)
        } else {
          console.log("hi")
          setSefareshat("سفارشی یافت نشد");
        }
      })
      .catch((e) => {
        setSefareshat("سفارشی یافت نشد");
        console.log(e);
      });
      setShowSefareshat(true)
  };

  const changePass = () => {
    if (
      alreadyPass === "" ||
      newPass === "" ||
      repeatNewPass === "" ||
      alreadyPass.length < 4 ||
      newPass.length < 4 ||
      repeatNewPass.length < 4
    ) {
      setChangePassMsg("لطفا فیلد ها را تکمیل کنید (حداقل 4 کاراکتر)");
      setInterval(() => {
        setChangePassMsg("");
      }, 5000);
      return;
    }
    if (newPass !== repeatNewPass) {
      setChangePassMsg("رمزعبور جدید با تکرار آن متفاوت است");
      setInterval(() => {
        setChangePassMsg("");
      }, 5000);
      return;
    }

    if (alreadyPass === newPass) {
      setChangePassMsg("رمز عبور جدید با رمز قبلی باید متفاوت باشد");
      setInterval(() => {
        setChangePassMsg("");
      }, 5000);
      return;
    }

    const form = new FormData();
    form.append("change_pass", 1);
    form.append("mobile", loginContext.userInfo.mobile);
    form.append("vitrinCode", loginContext.userInfo.vitrinCode);
    form.append("oldPass", alreadyPass);
    form.append("newPass", newPass);

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setShowChangePass(false);
          setAlreadyPass("");
          setNewPass("");
          setRepeatNewPass("");
          setShowChangePassRes([true, data.data]);
        } else {
          setAlreadyPass("");
          setNewPass("");
          setRepeatNewPass("");
          setChangePassMsg(data.data);
          setInterval(() => {
            setChangePassMsg("");
          }, 5000);
        }
      });
  };

  const modal = () => {
    return (
      <>
        {/*========login Modal========*/}
        <Modal
          show={showLogin}
          onHide={() => setShowLogin(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            <h2>ورود</h2>
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {!isLoading ? (
              <>
                <div className="mt-3">
                  <h6>موبایل</h6>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="11"
                    className={
                      !loginMobileValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="موبایل"
                    value={loginMobile}
                    onChange={setLoginMobileInput}
                  ></input>
                </div>
                <div>
                  <h6>رمزعبور</h6>
                  <input
                    className={
                      !loginPassValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="رمزعبور"
                    type="password"
                    value={loginPass}
                    onChange={setLoginPassInput}
                  ></input>
                  <p className="text-danger mt-2">{showLoginMsg}</p>
                </div>
              </>
            ) : (
              loader()
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button className="btn btn-outline-info" onClick={showForget}>
              فراموشی رمزعبور
            </button>
            <button
              className="btn btn-danger"
              onClick={() => setShowLogin(false)}
            >
              انصراف
            </button>
            <button className="btn btn-primary" onClick={login}>
              ورود
            </button>
          </Modal.Footer>
        </Modal>
        {/* ================================ */}

        {/* ========SignUp Modal======== */}
        <Modal
          show={showSignup}
          onHide={() => {
            setShowSignup(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            <h2>ثبت نام</h2>
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {!isLoading ? (
              <>
                <div className="mt-4">
                  <input
                    type="text"
                    className={
                      !signUpNameValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="نام و نام خانوادگی"
                    value={signUpName}
                    onChange={setSignUpNameInput}
                  ></input>
                </div>
                <div className="mt-4">
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="11"
                    className={
                      !signUpMobileValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="موبایل"
                    value={signUpMobile}
                    onChange={setSignUpMobileInput}
                  ></input>
                </div>
                <div>
                  <h6 className="mt-2">رسته</h6>
                  <select
                    className="form-control rtl"
                    value={signUpWork}
                    onChange={setSignUpWorkInput}
                  >
                    <option value={"مشتری خانگی"}>مشتری خانگی</option>
                    <option value={"طلا فروش"}>طلا فروش</option>
                    <option value={"جواهر فروش"}>جواهر فروش</option>
                    <option value={"بنکدار"}>بنکدار</option>
                    <option value={"سازنده"}>سازنده</option>
                    <option value={"کیفی"}>کیفی</option>
                    <option value={"متفرقه"}>متفرقه</option>
                  </select>
                </div>
                <div className="mt-4">
                  <textarea
                    className={
                      !signUpAddressValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="آدرس"
                    value={signUpAddress}
                    onChange={setSignUpAddressInput}
                  ></textarea>
                </div>
                <div className="mt-4">
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="11"
                    className={
                      !signUpMoarefValidate
                        ? "form-control is-invalid rtl"
                        : "form-control rtl"
                    }
                    placeholder="موبایل معرف"
                    value={signUpMoaref}
                    onChange={setSignUpMoarefInput}
                  />
                </div>
              </>
            ) : (
              loader()
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-danger"
              onClick={() => setShowSignup(false)}
            >
              انصراف
            </button>
            <button className="btn btn-primary" onClick={signUp}>
              ثبت نام
            </button>
          </Modal.Footer>
        </Modal>
        {/* ================================ */}

        {/* ========forgetPass Modal======== */}
        <Modal
          show={showForgetPass}
          onHide={() => {
            setShowForgetPass(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            <h2>فراموشی رمز عبور</h2>
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {!isLoading ? (
              <div>
                <h6 className="mt-3">موبایل</h6>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="11"
                  className={
                    !loginMobileValidate
                      ? "form-control is-invalid rtl"
                      : "form-control rtl"
                  }
                  placeholder="موبایل"
                  value={loginMobile}
                  onChange={setLoginMobileInput}
                ></input>
              </div>
            ) : (
              loader()
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-danger"
              onClick={() => setShowForgetPass(false)}
            >
              انصراف
            </button>
            <button className="btn btn-primary" onClick={forgetPass}>
              ثبت
            </button>
          </Modal.Footer>
        </Modal>
        {/* ================================ */}

        {/* ========SignUpMsg Modal======== */}
        <Modal
          show={showSignUpMsg[0]}
          onHide={() => setShowSignUpMsg([false, ""])}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {showSignUpMsg[1]}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowSignUpMsg([false, ""])}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
        {/* ================================ */}

        {/* ========ForgetPassMsg Modal======== */}
        <Modal
          show={showForgetMsg[0]}
          onHide={() => setShowForgetMsg([false, ""])}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {showForgetMsg[1]}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowForgetMsg([false, ""])}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
        {/* ================================ */}
      </>
    );
  };

  if (!loginContext.loginState) {
    return (
      <div>
        <Navbar
          bg={theme === "light" ? "light" : "dark"}
          expand="lg"
          className="rtl"
        >
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Nav.Link
                onClick={() => setShowLogin(true)}
                href="#"
                className="text-success"
              >
                ورود
              </Nav.Link>
              <Nav.Link
                onClick={() => setShowSignup(true)}
                href="#"
                className="text-primary"
              >
                ثبت نام
              </Nav.Link>
              <Faq />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {modal()}
      </div>
    );
  } else {
    return (
      <div>
        <Navbar bg={theme === "light" ? "light" : "dark"} expand="lg">
          <Navbar.Brand
            className={theme === "light" ? "rtl text-dark" : "text-light"}
          >
            {loginContext.userInfo.name}
            {parseFloat(loginContext.userInfo.darsad) > 0
              ? "(تخفیف" + parseFloat(loginContext.userInfo.darsad) + "%)"
              : null}
            {loginContext.userInfo.isModir ? <>{"(مدیر)"}</> : null}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="rtl" />

          <Navbar.Collapse id="basic-navbar-nav" className="rtl">
            <Nav className="rtl">
              {!loginContext.userInfo.isModir ? (
                <Profile vitrinCode={props.id} />
              ) : null}
              {loginContext.userInfo.isModir ? (
                <>
                  <Moshtarian id={props.id} />
                  <AddModir vitrinCode={props.id} />
                  <Upload type={"background"} vitrinCode={props.id} />
                  <Share vitrinCode={props.id} />
                  <Report vitrinCode={props.id} />
                  <VitrinMessage vitrinCode={props.id} />
                  <ManageComments vitrinCode={props.id} />
                  <ManageMsgToModir vitrinCode={props.id} />
                </>
              ) : null}
              {!loginContext.userInfo.isModir ? (
                <>
                  <MessageToModir vitrinCode={props.id} />
                  <FeeSale />
                  <Nav.Link
                    onClick={() => {
                      setShowChangePass(true);
                    }}
                    href="#"
                    className="text-info"
                  >
                    تغییر رمز عبور
                  </Nav.Link>
                </>
              ) : null}
              <Nav.Link
                onClick={() => {
                  if (loginContext.userInfo.isModir) {
                    sefareshatFunc();
                  } else {
                    history();
                  }
                }}
                href="#"
                className={theme === "light" ? "text-dark" : "text-light"}
              >
                سفارشات
              </Nav.Link>
              <Order vitrinCode={props.id} />

              <Faq />

              <Nav.Link onClick={logout} href="#" className="text-danger">
                خروج
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Modal
          show={showSefareshat}
          onHide={() => setShowSefareshat(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            سابقه سفارشات
          </Modal.Header>
          <Modal.Body className={theme === "light" ? "bg-light" : "bg-dark"}>
            {sefareshat !== "سفارشی یافت نشد" ? (
              <Accordion defaultActiveKey="0">
                {sefareshat.map((item, index) => (
                  <Card key={index}>
                    <Accordion.Toggle as={Card.Header} eventKey={index}>
                      <p>
                        {"نام خریدار : " +
                          item.name_kharidar +
                          "(" +
                          item.mobile_kharidar +
                          ") " +
                          " - " +
                          item.date}
                      </p>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index}>
                      <Card.Body>
                        <table className="table table-responsive-sm bg-table mt-3 rtl">
                          <thead>
                            <tr>
                              <th scope="col">ردیف</th>
                              <th scope="col">کد محصول</th>
                              <th scope="col">نام محصول</th>
                              <th scope="col">وزن</th>
                              <th scope="col">قیمت</th>
                            </tr>
                          </thead>
                          <tbody>
                          {item.detail!==null?
                            item.detail.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.barcodeKar}</td>
                                <td>{item.kalaName}</td>
                                <td>{item.vazn}</td>
                                <td>{item.price}</td>
                              </tr>
                            )):null}
                          </tbody>
                        </table>
                        {/* {sefareshat.radif.map((item2, index2) => (
                          
                        ))} */}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ))}
              </Accordion>
            ) : (
              <p>{sefareshat}</p>
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowSefareshat(false)}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showHistory}
          onHide={() => setShowHistory(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            سابقه سفارشات
          </Modal.Header>
          <Modal.Body className={theme === "light" ? "bg-light" : "bg-dark"}>
            {historyResult !== "سفارشی یافت نشد" ? (
              <Accordion defaultActiveKey="0">
                {historyResult.map((item, index) => (
                  <Card key={index}>
                    <Accordion.Toggle as={Card.Header} eventKey={index}>
                      {"شماره سفارش :" + item.num + " (" + item.date + ")"}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index}>
                      <Card.Body>
                        {item.radif.map((item2, index2) => (
                          <p key={index2} className="rtl">
                            {item2.radifNum + ") " + item2.kala}
                          </p>
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ))}
              </Accordion>
            ) : (
              <p>{historyResult}</p>
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowHistory(false)}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showChangePass}
          onHide={() => setShowChangePass(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            تغییر رمز عبور
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <div className="mt-3">
              <h6>رمزعبور فعلی</h6>
              <input
                className={"form-control rtl"}
                placeholder="رمزعبور فعلی"
                type="password"
                value={alreadyPass}
                onChange={setAlreadyPassInput}
              ></input>
            </div>
            <div className="mt-3">
              <h6>رمزعبور جدید</h6>
              <input
                className={"form-control rtl"}
                placeholder="رمزعبور جدید"
                type="password"
                value={newPass}
                onChange={setNewPassInput}
              ></input>
            </div>
            <div className="mt-3">
              <h6>تکرار رمزعبور جدید</h6>
              <input
                className={"form-control rtl"}
                placeholder="تکرار رمزعبور جدید"
                type="password"
                value={repeatNewPass}
                onChange={setRepeatPassInput}
              ></input>
            </div>
            <p className="text-danger mt-3">{changePassMsg}</p>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button className="btn btn-primary" onClick={changePass}>
              ثبت
            </button>
            <button
              className="btn btn-dark"
              onClick={() => setShowChangePass(false)}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showChangePassRes[0]}
          onHide={() => setShowChangePassRes([false, ""])}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {showChangePassRes[1]}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowChangePassRes([false, ""])}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
};
export default Login;
